var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArowForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 8,
    viewBox: "0 0 62 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.3536 4.35355C61.5488 4.15829 61.5488 3.8417 61.3536 3.64644L58.1716 0.464461C57.9763 0.269199 57.6597 0.269199 57.4645 0.464461C57.2692 0.659723 57.2692 0.976306 57.4645 1.17157L60.2929 3.99999L57.4645 6.82842C57.2692 7.02368 57.2692 7.34027 57.4645 7.53553C57.6597 7.73079 57.9763 7.73079 58.1716 7.53553L61.3536 4.35355ZM4.37114e-08 4.5L61 4.49999L61 3.49999L-4.37114e-08 3.5L4.37114e-08 4.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArowForward);
export default __webpack_public_path__ + "static/media/arow_forward.748d12cf5263fb24fe78313d3b243f42.svg";
export { ForwardRef as ReactComponent };